"use strict";
(function (global) {

  /**
  * Редактор для ячейки с реквизитом типа pick.  
  * @class WebAccess.components.dataViews.gridPlugins._editors.PickEditor
  * @extends WebAccess.components.dataViews.gridPlugins._editors.StringEditor
  * @since 5.2.0.1300
  */
  global.PickEditor = global.StringEditor.extend({
    _renderer: null,
    _wrapper: null,

    init: function (args) {
      var me = this;
      me._super(args);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Рендеринг и добавление контрола реквизита в ячейку грида
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._editors.PickEditor#render
    */
    render: function () {
      var me = this;


      me._data.id = me.id;
      
      me._data.selectedKey = me._value;
      me._data.selectedValue = me._displayValue;

      me._renderer = new WebAccess.components.forms.requisites.Pick();

      me._renderer.renderAsync(me._data).done(function (html) {
        me._jContainer.html('<div class="pickEditor editor">' + html + '</div>');
        me._jContainer.find('input.input').addClass('noBorder');
        
        me._jInput = $('#' + me.id);
        me.initKeyNavigation();
        me.renderState.resolve();
      });
      return me.renderState
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    initKeyNavigation: function() {
      this._super();

      this._jInput.bind("keydown.nav", function (e) {
        var key = e.keyCode;
        var c = $.ui.keyCode;

        if ((key === c.DOWN || key === c.UP) && e.altKey) {
          e.stopImmediatePropagation();
        };
      })      
    },

    _handleUpDownKey: function () {
      //не вызываем родительский метод, чтобы не поломать ALT+вниз
    },

    /**
    * Получить объект-обертку над контролом реквизита, с необходимыми методами типа getValue;
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._editors.PickEditor#_getWrapper
    */
    _getWrapper: function () {
      var me = this;
      if (!!me._wrapper) return me._wrapper;
      var parentCurrent = me._gridComp._parent.settings.current;
      return me._wrapper = new WA.CMP.wrappers.form.requisites.Pick(me._column.id, me.id, parentCurrent.form);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак того что значение ячейки изменилось
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._editors.PickEditor#isValueChanged
    */
    isValueChanged: function () {
      var me = this;
      var values = me.serializeValue();
    
      if (me._value !== values.value) {
        me._value = values.value;
        return true;
      }
      return false
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  
    /**
     * Очистка поля
     * @method WebAccess.components.dataViews.gridPlugins._editors.PickEditor#destroy
     * @since 5.2.0.1300     
     */
    destroy: function () {
      var me = this;
      me._jInput.HidePickContainer();
      me._super();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Метод вызывается когда значение в ячейке изменилось, и передает данные из
    * редактора в набор данных грида.
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._editors.PickEditor#serializeValue
    */
    serializeValue: function () {
      var me = this;      
      var control = me._getWrapper();      
      return {
        'value': control.getValue(),
        'displayValue': control.getDisplayValue()
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    clearValues: function () {
      var wrapper = this._getWrapper();
      wrapper.clearValues.apply(wrapper, arguments);
    },

    addValue: function () {
      var wrapper = this._getWrapper();
      wrapper.addValue.apply(wrapper, arguments);
    },

    
  });

})(window.WA.components.dataViews.gridPlugins._editors)